export default function DataInputIcon({ className }: { className?: string }) {
    return (
        <svg
            className={`${className} w-8 h-8`}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.46875 16.0002H13.4688"
                stroke="currentFill"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.4688 19.2727L13.4688 16L10.4688 12.7273"
                stroke="currentFill"
                strokeWidth="2"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.53125 11.6364V6H26.5312V26H6.53125V20.3636H4.53125V27C4.53125 27.5523 4.97897 28 5.53125 28H27.5312C28.0835 28 28.5312 27.5523 28.5312 27V5C28.5312 4.44772 28.0835 4 27.5312 4H5.53125C4.97897 4 4.53125 4.44772 4.53125 5V11.6364H6.53125Z"
                fill="currentColor"
                stroke="transparent"
            />
        </svg>
    );
}
